import { css } from "@emotion/react"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const benefits = css`
  .iq-accordion {
    margin-bottom: 24px;

    + .iq-text {
      margin-bottom: 48px;
    }

    &__head-content {
      padding-right: 24px;
      font-size: 20px;
      font-weight: 500;
    }

    &__item-body {
      padding: 0 !important;
    }

    &__item-body {
      ul,
      ol {
        padding-left: 20px;
        li {
          list-style: disc;
          margin-bottom: 10px;
        }
      }
    }
  }
`
export const item = css`
  margin-bottom: 24px;
`
export const label = css`
  margin-bottom: 16px;
  display: flex;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${colorsCP["neutral-50"]};

  .iq-icon {
    margin-right: 8px;
    color: ${colorsCP["emerald-50"]};
  }
`
export const value = css`
  font-size: 14px;
  line-height: 22px;
  margin-top: 24px;
  margin-left: 5px;

  p {
    margin-bottom: 20px;
  }
`
